module.exports = __webpack_public_path__ + "img/leval-4.7c82628d.png";